import { StaticJsonRpcProvider } from '@ethersproject/providers';

import environments from '../utils/environments';

const { PUBLIC_RPC_URL, REACT_CHAIN_NAME } = environments;

const MIN_PRIORITY_FEE_PER_GAS = 20000000000; // 20 Gwei (on Ronin)
const MAX_FEE_MULTIPLIER = 11n / 10n; // Small 10% buffer for base fee fluctuations

class WrappedJsonProvider extends StaticJsonRpcProvider {
  async getCustomizedFeeData() {
    const feeData = await this.getFeeData();

    if (!feeData || !feeData.maxFeePerGas) {
      throw new Error('Invalid fee data from RPC');
    }

    // Work with BigInt throughout for iOS compatibility
    const maxPriorityFee = BigInt(feeData.maxPriorityFeePerGas || 0);
    const minPriorityFee = BigInt(MIN_PRIORITY_FEE_PER_GAS);
    const maxPriorityFeePerGas = maxPriorityFee > minPriorityFee ? maxPriorityFee : minPriorityFee;

    const maxFee = BigInt(feeData.maxFeePerGas);
    const baseFee = maxFee - BigInt(feeData.maxPriorityFeePerGas || 0);

    // Use BigInt math, then convert to hex
    const maxFeePerGas = baseFee * MAX_FEE_MULTIPLIER + maxPriorityFeePerGas;

    // Return hex strings - universally compatible (iOS/Android/Desktop)
    return {
      maxFeePerGas: `0x${maxFeePerGas.toString(16)}`,
      maxPriorityFeePerGas: `0x${maxPriorityFeePerGas.toString(16)}`,
      gasPrice: feeData.gasPrice ? `0x${BigInt(feeData.gasPrice).toString(16)}` : undefined,
    };
  }
}

export const customChainNetwork = {
  name: REACT_CHAIN_NAME,
  chainId: parseInt(process.env.REACT_APP_CHAIN_ID || '0', 10),
};

export const provider = new WrappedJsonProvider(PUBLIC_RPC_URL, customChainNetwork);
